import SmsScreen from "components/shared/SmsScreen"
import {
  ACCESS_RESTRICTED_TEXT,
  REDIRECT_TO_CONTACT_US_TEXT
} from "shared/constants"

import {
  useForceAuthEffect,
  useVerificationRedirectEffect
} from "components/Login/hooks"
import makeAsyncScriptLoader from "react-async-script"
import { generateRedirectUrl } from "shared/helpers/url"
import portal from "portalConfig"
import restrictedIcon from "./assets/access-restricted.svg"

const { features } = portal.config

const AccessRestricted = () => {
  useForceAuthEffect({ authUrl: "/login" })
  useVerificationRedirectEffect()

  let buttons
  if (features.showAdaSupport) {
    buttons = [
      {
        text: ACCESS_RESTRICTED_TEXT.contactButton,
        primary: true,
        onClick: () => {
          if (window.adaEmbed) {
            window.adaEmbed.start({
              handle: "honk",
              adaReadyCallback: () => {
                window.adaEmbed.toggle()
              },
              toggleCallback: (isDrawerOpen) => {
                if (!isDrawerOpen) {
                  window.adaEmbed.stop()
                }
              },
              metaFields: {}
            })
          }
        }
      }
    ]
  } else {
    buttons = [
      {
        text: ACCESS_RESTRICTED_TEXT.contactButton,
        primary: true,
        to: generateRedirectUrl("/support/contact-us", {
          destUrl: `${process.env.REACT_APP_RSVP_BASE}/support/contact-us`,
          originUrl: `${process.env.REACT_APP_RSVP_BASE}/sms-blocked`,
          text: REDIRECT_TO_CONTACT_US_TEXT
        }),
        external: true
      }
    ]
  }
  return (
    <SmsScreen
      heading={ACCESS_RESTRICTED_TEXT.heading}
      description={ACCESS_RESTRICTED_TEXT.description}
      icon={restrictedIcon}
      hideBackButton
      showLogoutButton
      buttons={buttons}
    />
  )
}

let Component = AccessRestricted

if (features.showAdaSupport) {
  Component = makeAsyncScriptLoader("https://static.ada.support/embed2.js", {
    scriptId: "__ada",
    attributes: {
      "data-handle": "honk",
      "data-lazy": true
    }
  })(AccessRestricted)
}

export default Component
